// src/pages/SearchTab.jsx
import React from "react";
import useMessageSearch from "../func/useMessageSearch";
import SearchForm from "../components/SearchForm";
import MessageList from "../components/MessageList";

function SearchTab({ apiToken }) {
    const {
        content,
        userId,
        specifyDay,
        date,
        messages,
        loading,
        hasMore,
        searchByUsername,
        contextMessages,
        contextAnchorMessageId,
        hasOlderContext,
        hasNewerContext,
        loadingContext,
        loadingOlderContext,
        loadingNewerContext,
        setContent,
        setUserId,
        setSpecifyDay,
        setDate,
        setSearchByUsername,
        resetMessages,
        fetchMessages,
        fetchMessageContext,
        fetchOlderContext,
        fetchNewerContext,
    } = useMessageSearch(apiToken);

    function handleSearch() {
        resetMessages();
        fetchMessages();
    }

    function handleFetchMore() {
        fetchMessages();
    }

    function handleViewContext(messageId) {
        fetchMessageContext(messageId);
    }

    return (
        <div className="flex h-full min-h-0 flex-col gap-5">
            <div>
                <h2 className="text-3xl font-bold tracking-normal text-slate-800 dark:text-white">
                    Message Search
                </h2>
            </div>

            <section className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-800 sm:p-5">
                <SearchForm
                    content={content}
                    userId={userId}
                    specifyDay={specifyDay}
                    date={date}
                    searchByUsername={searchByUsername}
                    setContent={setContent}
                    setUserId={setUserId}
                    setSpecifyDay={setSpecifyDay}
                    setDate={setDate}
                    setSearchByUsername={setSearchByUsername}
                    onSearch={handleSearch}
                />
            </section>

            <section className="min-h-0 flex-1 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800">
                <MessageList
                    messages={messages}
                    loading={loading}
                    hasMore={hasMore}
                    fetchMoreMessages={handleFetchMore}
                    contextMessages={contextMessages}
                    contextAnchorMessageId={contextAnchorMessageId}
                    loadingContext={loadingContext}
                    loadingOlderContext={loadingOlderContext}
                    loadingNewerContext={loadingNewerContext}
                    hasOlderContext={hasOlderContext}
                    hasNewerContext={hasNewerContext}
                    onViewContext={handleViewContext}
                    onFetchOlderContext={fetchOlderContext}
                    onFetchNewerContext={fetchNewerContext}
                />
            </section>
        </div>
    );
}

export default SearchTab;
